"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBottle2 = function IconBottle2(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M25 4h9v5h-9zm7 3V6h-5v1zM21 8h-8v5h8zm-2 2v1h-4v-1zm8 6.414V10h-2l-.001 5.585-2.536 2.538-.182.192a5 5 0 0 0-.423.542L21 17.959V14h-2v4.76l2.056 2.153a5 5 0 0 0-.056.748V37h-8.43l-.092-.008A.57.57 0 0 1 12 36.43V22.76l.007-.183a2.12 2.12 0 0 1 .584-1.294L15 18.76V14h-2v3.958l-1.853 1.941-.153.169A4.12 4.12 0 0 0 10 22.763V36.43l.005.163A2.57 2.57 0 0 0 12.57 39H21v2l.005.176A3 3 0 0 0 24 44h11l.176-.005A3 3 0 0 0 38 41V21.66l-.007-.264a5 5 0 0 0-1.456-3.273L34 15.584 34 10h-2v6.414l3.123 3.123.135.145A3 3 0 0 1 36 21.659V25h-7v13h7v3l-.007.117A1 1 0 0 1 35 42H24l-.117-.007A1 1 0 0 1 23 41V21.66l.006-.198a3 3 0 0 1 .872-1.925zM36 37V26h-6v11zM14 27v8h-1v-8zm0-1v-2h-1v2z",
    clipRule: "evenodd"
  })));
};

export { IconBottle2, IconBottle2 as default };
